import React, { useEffect, useState, createElement } from 'react';
import { CheckCircle2Icon, XCircleIcon, StarIcon, ShieldCheckIcon, ZapIcon, UsersIcon, BookOpenIcon, GiftIcon, ArrowRightIcon, LockIcon, CreditCardIcon, GlobeIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Timer } from './components/Timer';
import { Roadmap } from './components/Roadmap';
import { Accordion } from './components/Accordion';
import { SocialProofPopup } from './components/SocialProofPopup';
export function App() {
  const [selectedPack, setSelectedPack] = useState<null | 'megapack' | 'elite'>(null);
  useEffect(() => {
    // Meta Pixel Initialization
    const initMetaPixel = () => {
      // @ts-ignore
      if (window.fbq) return;
      // @ts-ignore
      const n = window.fbq = function () {
        // @ts-ignore
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      // @ts-ignore
      if (!window._fbq) window._fbq = n;
      // @ts-ignore
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      // @ts-ignore
      n.queue = [];
      const t = document.createElement('script');
      t.async = !0;
      t.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(t);
      // @ts-ignore
      fbq('init', '1313291250496067');
      // @ts-ignore
      fbq('track', 'PageView');
    };
    initMetaPixel();
  }, []);
  const pulseAnimation = {
    scale: [1, 1.02, 1],
    transition: {
      duration: 2,
      repeat: Infinity,
      ease: 'easeInOut'
    }
  };
  const packs = {
    megapack: {
      name: 'MEGAPACK INICIAL',
      price: '$19.990',
      oldPrice: '$536 USD',
      link: 'https://checkout.guiadigital360.online/cart/44854830039109:1',
      cta: 'QUIERO MI MEGAPACK INICIAL',
      color: 'brand-green'
    },
    elite: {
      name: 'PACK ÉLITE',
      price: '$24.990',
      oldPrice: '$736 USD',
      link: 'https://checkout.guiadigital360.online/cart/44855686692933:1',
      cta: 'QUIERO MI PACK ÉLITE',
      color: 'brand-gold'
    }
  };
  return <div className="min-h-screen selection:bg-brand-green selection:text-black" data-id="element-0">
      <SocialProofPopup data-id="element-1" />
      {/* Sticky Header */}
      <header className="sticky top-0 z-50 bg-brand-navy/90 backdrop-blur-md border-b border-white/10 py-3 px-4" data-id="element-2">
        <div className="max-w-6xl mx-auto flex justify-between items-center" data-id="element-3">
          <div className="flex items-center gap-2" data-id="element-4">
            <div className="w-8 h-8 bg-brand-green rounded flex items-center justify-center text-black font-black" data-id="element-5">
              F
            </div>
            <span className="font-montserrat font-extrabold text-xl tracking-tighter" data-id="element-6">
              F500 FREELANCE<span className="text-brand-green" data-id="element-7">™</span>
            </span>
          </div>
          <a href="#pricing" className="bg-brand-green text-black px-4 py-2 rounded-full font-montserrat font-bold text-sm hover:scale-105 transition-transform neon-glow hidden md:block" data-id="element-8">
            QUIERO MI F500
          </a>
        </div>
      </header>

      <main data-id="element-9">
        {/* Hero Section */}
        <section className="relative pt-8 pb-6 md:pt-20 md:pb-16 px-4 overflow-hidden" data-id="element-10">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full bg-[radial-gradient(circle_at_center,rgba(0,212,170,0.1)_0%,transparent_70%)] pointer-events-none" data-id="element-11" />
          <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-12">
            <div className="inline-block bg-brand-green/10 text-brand-green border border-brand-green/20 px-4 py-1 rounded-full font-bold mb-6 text-[24px]" data-id="element-13">
              🟢 TU PRIMEROS $500 💵 COMO FREELANCER LISTO.
            </div>
            <h1 className="md:text-7xl font-black mb-6 text-[32px]" data-id="element-14">
              En menos de{' '}
              <div className="text-brand-green underline decoration-brand-green/30" data-id="element-15">
                30 días.
              </div>
            </h1>

            <div className="mb-6 md:mb-10 flex justify-center" data-id="element-16">
              <img src="https://cdn.magicpatterns.com/uploads/d2pU9pf7oy1pqSo1psScQQ/f500_mobile_768.webp" alt="F500 Mega Pack Mockup" className="w-full max-w-2xl rounded-2xl shadow-2xl shadow-brand-green/10 border border-white/5" data-id="element-17" />
            </div>

            <p className="text-xl md:text-2xl text-gray-300 mb-6 md:mb-8 max-w-2xl mx-auto" data-id="element-18">
              F500 Freelance MegaPack — El sistema N°1 para ganar en dólares
              desde Latinoamérica sin experiencia previa.
            </p>

            <div className="flex flex-col items-center gap-4" data-id="element-19">
              <motion.a href="#pricing" animate={pulseAnimation} className="w-full md:w-auto bg-brand-green text-black px-10 py-5 rounded-xl font-montserrat font-black text-xl hover:scale-105 transition-all neon-glow flex items-center justify-center gap-2 group" data-id="element-20">
                QUIERO MI F500 AHORA{' '}
                <ArrowRightIcon className="group-hover:translate-x-1 transition-transform" data-id="element-21" />
              </motion.a>
              <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-400 mt-4" data-id="element-22">
                <span className="flex items-center gap-1" data-id="element-23">
                  <ShieldCheckIcon size={16} className="text-brand-green" data-id="element-24" />{' '}
                  Garantía 7 días
                </span>
                <span className="flex items-center gap-1" data-id="element-25">
                  <LockIcon size={16} className="text-brand-green" data-id="element-26" /> Pago
                  seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-27">
                  <CreditCardIcon size={16} className="text-brand-green" data-id="element-28" />{' '}
                  Mercado Pago
                </span>
              </div>
            </div>
          </div>
        </section>

        {/* Social Proof Stats */}
        <section className="bg-brand-darker border-y border-white/5 py-6 md:py-10 px-4" data-id="element-29">
          <div className="max-w-6xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-8 text-center" data-id="element-30">
            <div data-id="element-31">
              <div className="text-4xl font-black text-brand-green mb-1" data-id="element-32">
                +500
              </div>
              <div className="text-xs uppercase tracking-widest text-gray-400" data-id="element-33">
                Compradores confían
              </div>
            </div>
            <div data-id="element-34">
              <div className="text-4xl font-black text-brand-green mb-1" data-id="element-35">5</div>
              <div className="text-xs uppercase tracking-widest text-gray-400" data-id="element-36">
                Tomos listos
              </div>
            </div>
            <div data-id="element-37">
              <div className="text-4xl font-black text-brand-green mb-1" data-id="element-38">3</div>
              <div className="text-xs uppercase tracking-widest text-gray-400" data-id="element-39">
                Bonos incluidos
              </div>
            </div>
            <div data-id="element-40">
              <div className="text-4xl font-black text-brand-green mb-1" data-id="element-41">
                4,9/5
              </div>
              <div className="text-xs uppercase tracking-widest text-gray-400" data-id="element-42">
                Calificación ⭐
              </div>
            </div>
          </div>
        </section>

        {/* Testimonials Hero */}
        <section className="py-8 md:py-20 px-4 max-w-6xl mx-auto" data-id="element-43">
          <div className="grid md:grid-cols-3 gap-6" data-id="element-44">
            {[{
            name: 'Valentina L.',
            loc: 'Mendoza',
            role: 'Community Manager',
            text: 'Apliqué el Tomo 3 en la semana 2 y cerré mi primer cliente de $120. Nunca había ganado un dólar online.'
          }, {
            name: 'Rodrigo C.',
            loc: 'Bogotá',
            role: 'Redactor SEO',
            text: 'Las 100 plantillas del Bono 1 me ahorraron horas de trabajo. Solo copio, personalizo y envío. El 30% de mis propuestas responden.'
          }, {
            name: 'Sofía M.',
            loc: 'CDMX',
            role: 'VA Freelancer',
            text: 'En el Día 28 ya tenía $480 facturados. El sistema funciona exactamente como dice. El Tomo 4 de automatización fue clave.'
          }].map((t, i) => <div key={i} className="bg-white/5 border border-white/10 p-8 rounded-2xl" data-id="element-45">
                <div className="flex gap-1 mb-4" data-id="element-46">
                  {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className="fill-brand-gold text-brand-gold" data-id="element-47" />)}
                </div>
                <p className="text-lg mb-6 italic text-gray-200" data-id="element-48">"{t.text}"</p>
                <div className="flex items-center gap-3" data-id="element-49">
                  <div className="w-10 h-10 bg-brand-green/20 rounded-full flex items-center justify-center text-brand-green font-bold" data-id="element-50">
                    {t.name[0]}
                  </div>
                  <div data-id="element-51">
                    <div className="font-bold" data-id="element-52">{t.name}</div>
                    <div className="text-xs text-gray-400" data-id="element-53">
                      {t.loc} · {t.role}
                    </div>
                  </div>
                </div>
              </div>)}
          </div>
        </section>

        {/* Pain Points Section */}
        <section className="py-8 md:py-20 px-4 bg-brand-darker" data-id="element-54">
          <div className="max-w-4xl mx-auto" data-id="element-55">
            <h2 className="text-3xl md:text-5xl font-black mb-6 md:mb-8 text-center" data-id="element-56">
              ¿Cuántos meses más vas a seguir ganando en pesos mientras otros{' '}
              <span className="text-brand-green" data-id="element-57">ganan en dólares</span> desde
              su casa?
            </h2>
            <p className="text-gray-400 text-center mb-12 text-lg" data-id="element-58">
              Querés ganar en dólares online. Sabés que hay personas en Latam
              que lo hacen desde una laptop. Pero nadie te dijo exactamente cómo
              arrancar sin experiencia previa. No es falta de talento. Es falta
              de un sistema.
            </p>
            <div className="grid md:grid-cols-2 gap-4" data-id="element-59">
              {['Creaste perfil en Upwork pero nadie te responde', 'No sabés qué nicho elegir y aplicás a todo', 'Escribís propuestas genéricas que van al archivo', 'Tenés habilidades pero no sabés cómo mostrarlas', 'Ves videos de YouTube pero sin sistema completo', 'Inflación en Argentina y el sueldo no alcanza', 'Otro mes pasa y seguís en $0 freelance'].map((item, i) => <div key={i} className="flex items-start gap-3 bg-white/5 p-4 rounded-lg border border-white/5" data-id="element-60">
                  <XCircleIcon className="text-red-500 shrink-0 mt-1" size={20} data-id="element-61" />
                  <span className="text-gray-200" data-id="element-62">{item}</span>
                </div>)}
            </div>
            <div className="mt-8 text-center" data-id="element-63">
              <p className="text-2xl font-bold text-brand-green" data-id="element-64">
                ¿Y si este fuera el último mes que pasaste sin ganar en dólares?
              </p>
            </div>
          </div>
        </section>

        {/* Solution / Product Reveal */}
        <section className="py-8 md:py-20 px-4 max-w-5xl mx-auto" data-id="element-65">
          <div className="text-center mb-8 md:mb-16" data-id="element-66">
            <h2 className="text-4xl md:text-6xl font-black mb-6" data-id="element-67">
              🏆 F500 FREELANCE™ MEGAPACK
            </h2>
            <p className="text-xl text-brand-green font-bold mb-4" data-id="element-68">
              5 Tomos + 3 Bonos — Días 1 al 30
            </p>
            <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-69">
              El roadmap exacto de 30 días que llevó a +500 freelancers en Latam
              de $0 a su primer $500 real en dólares.
            </p>
          </div>

          <div className="bg-brand-darker border border-brand-green/30 rounded-3xl p-6 md:p-12 mb-8 md:mb-20" data-id="element-70">
            <h3 className="text-2xl font-bold mb-8 text-center" data-id="element-71">
              TU ROADMAP DE 30 DÍAS
            </h3>
            <Roadmap data-id="element-72" />
          </div>

          <div className="space-y-4" data-id="element-73">
            <h3 className="text-3xl font-black mb-8 flex items-center gap-3" data-id="element-74">
              <BookOpenIcon className="text-brand-green" data-id="element-75" /> 5 TOMOS COMPLETOS
            </h3>

            <Accordion title="📘 TOMO 1 — DÍAS 1 AL 7: Encuentra Tu Nicho + Perfil Pro" data-id="element-76">
              <p className="mb-4" data-id="element-77">
                Quiz de nicho, 20 nichos calientes Latam, perfil Upwork/Fiverr
                al 100%, keywords SEO, estrategia de precio escalera F500.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-78">
                Meta Día 7: Perfil activo + primer gig publicado.
              </div>
            </Accordion>

            <Accordion title="📗 TOMO 2 — DÍAS 8 AL 14: Portfolio Irresistible" colorClass="border-green-500" data-id="element-79">
              <p className="mb-4" data-id="element-80">
                30 plantillas Canva por nicho, método portfolio sin experiencia,
                before/after que impacta, primeras reseñas 5 estrellas.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-81">
                Meta Día 14: Portfolio activo + invitación cliente.
              </div>
            </Accordion>

            <Accordion title="📙 TOMO 3 — DÍAS 15 AL 21: Propuestas que Cierran" colorClass="border-orange-500" data-id="element-82">
              <p className="mb-4" data-id="element-83">
                Fórmula P.R.O.F.500, 50 propuestas copy/paste, manejo
                objeciones, follow-up 5 toques, IA para propuestas en 3 minutos.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-84">
                Meta Día 21: Primer $100 real garantizado.
              </div>
            </Accordion>

            <Accordion title="📕 TOMO 4 — DÍAS 22 AL 28: Escala a $500" colorClass="border-red-500" data-id="element-85">
              <p className="mb-4" data-id="element-86">
                Upsells que multiplican x3, Zapier + Calendly automatizados, CRM
                Notion, rutina 2h/día, tracker ingresos, clientes recurrentes.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-87">
                Meta Día 28: $400+ acumulados confirmados.
              </div>
            </Accordion>

            <Accordion title="📓 TOMO 5 — Días 29 AL 30+: Retención + $1K Forever" colorClass="border-gray-500" data-id="element-88">
              <p className="mb-4" data-id="element-89">
                Sistema retención 7 pasos, nurture clientes, plan $1k mes 2,
                subcontratación, ingresos semi-pasivos, roadmap $1k→$2k→$5k.
              </p>
              <div className="bg-brand-green/10 text-brand-green p-3 rounded font-bold text-sm" data-id="element-90">
                Meta Día 30: $500 LOCKED + base $1k construida.
              </div>
            </Accordion>
          </div>

          <div className="mt-12 grid grid-cols-2 md:grid-cols-4 gap-4" data-id="element-91">
            {['Roadmap diario', 'Templates listos', 'Casos de éxito', 'Trackers progreso'].map((item, i) => <div key={i} className="flex items-center gap-2 text-sm text-gray-300" data-id="element-92">
                <CheckCircle2Icon size={16} className="text-brand-green" data-id="element-93" />{' '}
                {item}
              </div>)}
          </div>
        </section>
        {/* Bonuses Section */}
        <section className="py-8 md:py-20 px-4 bg-brand-darker" data-id="element-94">
          <div className="max-w-6xl mx-auto" data-id="element-95">
            <h2 className="text-3xl md:text-5xl font-black mb-8 md:mb-12 text-center" data-id="element-96">
              🎁 3 BONOS ESTRATÉGICOS{' '}
              <span className="text-brand-green" data-id="element-97">INCLUIDOS</span>
            </h2>
            <div className="grid md:grid-cols-3 gap-8" data-id="element-98">
              {[{
              title: '100 Plantillas de Propuestas',
              price: '$97 USD',
              desc: 'Copia, personaliza en 3 minutos y enviá. 100 templates por nicho: redacción, diseño, VA, marketing e IA.'
            }, {
              title: 'Scripts Emails + Prompts IA',
              price: '$67 USD',
              desc: '50 emails listos para cada situación + 20 prompts ChatGPT para generar propuestas profesionales en 60 segundos.'
            }, {
              title: 'Lista 200 Leads Latam',
              price: '$127 USD',
              desc: '200 prospectos calificados organizados por nicho y país + sistema completo para convertirlos en clientes sin plataformas.'
            }].map((bono, i) => <div key={i} className="bg-brand-navy border border-white/10 p-8 rounded-2xl relative overflow-hidden group" data-id="element-99">
                  <div className="absolute top-0 right-0 bg-brand-green text-black px-4 py-1 font-bold text-xs" data-id="element-100">
                    GRATIS
                  </div>
                  <div className="text-brand-green font-black text-4xl mb-4" data-id="element-101">
                    0{i + 1}
                  </div>
                  <h3 className="text-xl font-bold mb-4" data-id="element-102">{bono.title}</h3>
                  <p className="text-gray-400 mb-6 text-sm leading-relaxed" data-id="element-103">
                    {bono.desc}
                  </p>
                  <div className="text-gray-500 line-through text-sm" data-id="element-104">
                    {bono.price}
                  </div>
                  <div className="text-brand-green font-bold" data-id="element-105">
                    GRATIS con tu F500
                  </div>
                </div>)}
            </div>
            <div className="mt-10 text-center bg-brand-green/5 border border-brand-green/20 p-6 rounded-xl" data-id="element-106">
              <span className="text-xl" data-id="element-107">
                Valor total bonos:{' '}
                <span className="line-through text-gray-500" data-id="element-108">$291 USD</span> →{' '}
                <span className="text-brand-green font-black" data-id="element-109">
                  GRATIS con tu MegaPack
                </span>
              </span>
            </div>
          </div>
        </section>

        {/* Urgency & Pricing */}
        <section id="pricing" className="min-h-[100svh] flex flex-col justify-center py-4 px-4 bg-brand-navy relative overflow-hidden" data-id="element-110">
          <div className="absolute top-0 left-0 w-full h-full bg-[radial-gradient(circle_at_center,rgba(0,212,170,0.05)_0%,transparent_70%)] pointer-events-none" data-id="element-111" />

          <div className="max-w-md mx-auto w-full flex flex-col gap-4 relative z-10" data-id="element-112">
            <div className="text-center mb-2" data-id="element-113">
              <h2 className="text-lg font-bold text-red-500 mb-1 flex items-center justify-center gap-2" data-id="element-114">
                <ZapIcon size={16} data-id="element-115" /> CIERRA EN:
              </h2>
              <Timer data-id="element-116" />
            </div>

            <div className="flex flex-col gap-3" data-id="element-117">
              {/* MegaPack Card */}
              <button onClick={() => setSelectedPack('megapack')} className={`w-full text-left transition-all duration-300 rounded-2xl border-2 p-4 relative ${selectedPack === 'megapack' ? 'bg-brand-green/10 border-brand-green shadow-[0_0_20px_rgba(0,212,170,0.2)]' : 'bg-white/5 border-white/10 opacity-70'}`} data-id="element-118">
                <div className="flex justify-between items-center mb-1" data-id="element-119">
                  <span className={`text-xs font-black tracking-wider ${selectedPack === 'megapack' ? 'text-brand-green' : 'text-gray-400'}`} data-id="element-120">
                    📘 MEGAPACK INICIAL
                  </span>
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'megapack' ? 'border-brand-green bg-brand-green' : 'border-white/20'}`} data-id="element-121">
                    {selectedPack === 'megapack' && <CheckCircle2Icon size={14} className="text-black" data-id="element-122" />}
                  </div>
                </div>
                <div className="flex items-baseline gap-2" data-id="element-123">
                  <span className="text-3xl font-black text-white" data-id="element-124">
                    $19.990
                  </span>
                  <span className="text-xs text-gray-500 line-through" data-id="element-125">
                    $536 USD
                  </span>
                </div>
                <p className="text-[10px] text-gray-400 mt-1 italic" data-id="element-126">
                  5 Tomos + 3 Bonos adicionales. Ideal para Empezar de cero y
                  ganar tus primeros $500 usd.
                </p>
              </button>

              {/* Elite Card */}
              <button onClick={() => setSelectedPack('elite')} className={`w-full text-left transition-all duration-300 rounded-2xl border-2 p-4 relative ${selectedPack === 'elite' ? 'bg-brand-gold/10 border-brand-gold shadow-[0_0_20px_rgba(255,215,0,0.2)]' : 'bg-white/5 border-white/10 opacity-70'}`} data-id="element-127">
                <div className="absolute -top-3 left-4 bg-brand-gold text-black px-3 py-0.5 rounded-full font-black text-[10px] z-10" data-id="element-128">
                  MÁS ELEGIDO ⭐
                </div>
                <div className="flex justify-between items-center mb-1" data-id="element-129">
                  <span className={`text-xs font-black tracking-wider ${selectedPack === 'elite' ? 'text-brand-gold' : 'text-gray-400'}`} data-id="element-130">
                    🏆 PACK ÉLITE
                  </span>
                  <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPack === 'elite' ? 'border-brand-gold bg-brand-gold' : 'border-white/20'}`} data-id="element-131">
                    {selectedPack === 'elite' && <CheckCircle2Icon size={14} className="text-black" data-id="element-132" />}
                  </div>
                </div>
                <div className="flex items-baseline gap-2" data-id="element-133">
                  <span className="text-3xl font-black text-brand-gold" data-id="element-134">
                    $24.990
                  </span>
                  <span className="text-xs text-gray-500 line-through" data-id="element-135">
                    $736 USD
                  </span>
                </div>

                <motion.div initial={false} animate={{
                height: selectedPack === 'elite' ? 'auto' : 0,
                opacity: selectedPack === 'elite' ? 1 : 0
              }} className="overflow-hidden" data-id="element-136">
                  <p className="text-[10px] text-brand-gold/80 mt-2 leading-relaxed" data-id="element-137">
                    Incluye todo Mega pack inicial + bono VIP =beneficios extra
                    y acceso mejorado para asegurar tus resultados.
                  </p>
                </motion.div>
                {!selectedPack && <p className="text-[10px] text-gray-400 mt-1 italic" data-id="element-138">
                    El camino más corto y seguro al éxito.
                  </p>}
              </button>
            </div>

            {/* Dynamic CTA */}
            <div className="mt-4" data-id="element-139">
              <motion.a href={selectedPack ? packs[selectedPack].link : '#'} onClick={e => !selectedPack && e.preventDefault()} animate={selectedPack ? pulseAnimation : {}} className={`w-full py-5 rounded-2xl font-montserrat font-black text-lg flex items-center justify-center gap-2 transition-all duration-300 ${selectedPack ? selectedPack === 'megapack' ? 'bg-brand-green text-black shadow-[0_0_30px_rgba(0,212,170,0.4)]' : 'bg-brand-gold text-black shadow-[0_0_30px_rgba(255,215,0,0.4)]' : 'bg-white/10 text-white/30 cursor-not-allowed border border-white/5'}`} data-id="element-140">
                {selectedPack ? packs[selectedPack].cta : 'SELECCIONÁ TU PACK'}
                <ArrowRightIcon size={20} className={selectedPack ? 'opacity-100' : 'opacity-20'} data-id="element-141" />
              </motion.a>
              <div className="flex justify-center gap-4 mt-4 text-[10px] text-gray-500 uppercase tracking-widest" data-id="element-142">
                <span className="flex items-center gap-1" data-id="element-143">
                  <LockIcon size={12} data-id="element-144" /> Pago seguro
                </span>
                <span className="flex items-center gap-1" data-id="element-145">
                  <ShieldCheckIcon size={12} data-id="element-146" /> Garantía 7 días
                </span>
              </div>
            </div>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="bg-brand-darker border-t border-white/10 py-16 px-4" data-id="element-147">
        <div className="max-w-6xl mx-auto grid md:grid-cols-2 gap-12" data-id="element-148">
          <div data-id="element-149">
            <div className="flex items-center gap-2 mb-6" data-id="element-150">
              <div className="w-8 h-8 bg-brand-green rounded flex items-center justify-center text-black font-black" data-id="element-151">
                F
              </div>
              <span className="font-montserrat font-extrabold text-xl tracking-tighter" data-id="element-152">
                F500 FREELANCE<span className="text-brand-green" data-id="element-153">™</span>
              </span>
            </div>
            <p className="text-gray-400 max-w-sm mb-6" data-id="element-154">
              El sistema N°1 para ganar tus primeros $500/mes como freelancer
              desde Latinoamérica. Porque trabajar en dólares desde tu casa no
              debería ser un misterio para nadie en Latam.
            </p>
            <div className="text-brand-green font-bold text-lg" data-id="element-155">
              "Tu primer $500 está a 30 días."
            </div>
          </div>
          <div className="grid grid-cols-2 gap-8" data-id="element-156">
            <div data-id="element-157">
              <h4 className="font-bold mb-4 uppercase text-xs tracking-widest text-gray-500" data-id="element-158">
                Contacto
              </h4>
              <ul className="space-y-2 text-sm text-gray-400" data-id="element-159">
                <li data-id="element-160">soporte@guiadigital360.com</li>
                <li data-id="element-161">@guiadigital360</li>
                <li data-id="element-162">guiadigital360.com</li>
              </ul>
            </div>
            <div data-id="element-163">
              <h4 className="font-bold mb-4 uppercase text-xs tracking-widest text-gray-500" data-id="element-164">
                Legal
              </h4>
              <ul className="space-y-2 text-sm text-gray-400" data-id="element-165">
                <li data-id="element-166">© F500 Freelance™ 2026</li>
                <li data-id="element-167">guiadigital360</li>
                <li data-id="element-168">Todos los derechos reservados</li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    </div>;
}